module.exports = __webpack_public_path__ + "static/media/inventory.4eb0002a.svg";